import { render, staticRenderFns } from "./ServerSelectForm.vue?vue&type=template&id=64dc0e70&scoped=true&lang=pug&"
import script from "./ServerSelectForm.vue?vue&type=script&lang=js&"
export * from "./ServerSelectForm.vue?vue&type=script&lang=js&"
import style0 from "./ServerSelectForm.vue?vue&type=style&index=0&id=64dc0e70&lang=scss&scoped=true&"
import style1 from "./ServerSelectForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dc0e70",
  null
  
)

export default component.exports